var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlogr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.207 17c3.215 0 5.935-2.441 5.935-6.42s-2.72-6.398-5.935-6.398c-1.35 0-2.384.34-3.126 1.063V0H0v16.774h4.834v-1.017C5.576 16.593 6.678 17 8.207 17zm-1.214-3.979c-1.125 0-2.002-.836-2.002-2.441s.877-2.42 2.002-2.42c1.124 0 2 .815 2 2.42s-.876 2.441-2 2.441zM18.033 17C19.717 17 21 15.78 21 14.061c0-1.74-1.282-2.893-2.968-2.893s-2.968 1.152-2.968 2.893c0 1.718 1.282 2.939 2.968 2.939z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogr);
export default __webpack_public_path__ + "static/media/blogr.68f4bc4bb85b4aa267d0e1cb06775dc8.svg";
export { ForwardRef as ReactComponent };